module.exports = __webpack_public_path__ + "img/edit.ffe1f1fe.jpeg";